import React from 'react';
import { CheckCircle, Sparkles } from 'lucide-react';
import ServiceCTA from '../../components/ServiceCTA';
import RelatedServices from '../../components/RelatedServices';
import { Link } from 'react-router-dom';

const ConsultingService = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16" style={{ backgroundColor: '#FFF7FA' }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center fade-in">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
              ビジネスコンサルティング
            </h1>
            <p className="text-xl text-gray-700">
              お店の経営をサポートする優しい相談役。小さなお悩みでもお気軽に。
            </p>
          </div>
        </div>
      </section>

      {/* Main Content - 2 Column Layout */}
      <section className="section-spacing bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Left Column */}
              <div className="lg:col-span-2 space-y-8">
                <div className="rounded-2xl overflow-hidden shadow-md">
                  <img 
                    src="https://images.unsplash.com/photo-1758519289152-d64650d13c7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGNvbnN1bHRhdGlvbiUyMG1lZXRpbmd8ZW58MHx8fHwxNzY0NjUzNjk0fDA&ixlib=rb-4.1.0&q=85"
                    alt="ビジネスコンサルティング"
                    className="w-full h-auto object-cover"
                  />
                </div>

                <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    こんなことでお困りではありませんか？
                  </h2>
                  <ul className="space-y-3">
                    {[
                      '売上が伸び悩んでいる、何から始めていいかわからない',
                      '新規客が入ってこない、リピート率が低い',
                      'メニューやサービスを見直したいが、客観的な意見が欲しい',
                      '経営の相談相手がいない',
                      '開業したばかりで何をすればいいかわからない'
                    ].map((problem, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{problem}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    サービス内容
                  </h2>
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        売上アップ相談
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        現在の売上状況を一緒に分析し、売上を上げるための具体的な方法をご提案します。大手コンサルのような難しい話ではなく、小規模店舗に寄り添った現実的なアドバイスをいたします。
                      </p>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        メニュー・サービス改善
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        お客様の視点からメニューやサービスを見直し、より喜ばれる内容を一緒に考えます。無理なおすすめはせず、お店の個性を活かしながら改善していきます。
                      </p>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        店舗運営アドバイス
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        店舗のレイアウト、動線、接客など、日々の運営に関することまで幅広くサポート。客観的な意見と、他のお店の成功例を参考に、実践的なアドバイスをいたします。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    このサービスでできること
                  </h2>
                  <ul className="space-y-3">
                    {[
                      '売上を上げるための具体的な方法がわかる',
                      '第三者の客観的な意見を聞ける',
                      '経営の悩みを気軽に相談できる',
                      'お店の強みや改善点が明確になる',
                      '実践的ですぐに試せるアイデアが得られる'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    このサービスが向いている方
                  </h2>
                  <ul className="space-y-3">
                    {[
                      '開業したばかりで経営の相談相手が欲しい方',
                      '売上が伸び悩んでいる個人事業主',
                      'メニューやサービスを見直したい方',
                      '客観的な意見が欲しい方',
                      '気軽に相談できるパートナーが欲しい方'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start">
                        <Sparkles className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Right Column - Sidebar */}
              <div className="lg:col-span-1 space-y-6">
                <div className="bg-white rounded-2xl p-6 shadow-md border-2" style={{ borderColor: '#F7C9D3' }}>
                  <h3 className="text-xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
                    料金の目安
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">単発相談</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>10,000円～</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">月額サポート</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>25,000円～/月</p>
                    </div>
                    <Link to="/pricing" className="block text-center text-sm text-[#F7C9D3] hover:text-[#2C2C2C] font-medium mt-4">
                      詳しい料金を見る →
                    </Link>
                  </div>
                </div>

                <div className="rounded-2xl p-6 shadow-sm" style={{ backgroundColor: '#FFF7FA' }}>
                  <h3 className="text-xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
                    このサービスのポイント
                  </h3>
                  <ul className="space-y-3">
                    {[
                      '小規模店舗に寄り添う相談',
                      '実践的ですぐ試せる',
                      '単発・月額どちらもOK'
                    ].map((point, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-2 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-sm text-gray-700">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                  <p className="text-sm text-gray-600 mb-4">
                    このサービスについてもっと詳しく知りたい方
                  </p>
                  <Link to="/contact" className="btn-primary block py-3 rounded-full font-medium text-sm">
                    無料相談はこちら
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RelatedServices currentService="consulting" />
      <ServiceCTA />
    </div>
  );
};

export default ConsultingService;